import { render, staticRenderFns } from "./MerchantStatements.vue?vue&type=template&id=240e2567&scoped=true"
import script from "./MerchantStatements.vue?vue&type=script&lang=js"
export * from "./MerchantStatements.vue?vue&type=script&lang=js"
import style0 from "./MerchantStatements.vue?vue&type=style&index=0&id=240e2567&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240e2567",
  null
  
)

export default component.exports